import { TemplateHistoryApiResultObject } from "./TemplateHistoryApiResult";
import { CustomerNameId, 
         ItemNameNumber, 
         PromotionNameId, 
         ProductLineCategoryNameNumber, 
         ProductLineNameNumber } from "./TemplateMetadataModels";

export type PromotionExpirationTemplateHistoryApiResultObject = 
    TemplateHistoryApiResultObject & 
    PromotionExpirationTemplateHistoryMetadata;

export type PromotionExpirationTemplateHistoryMetadata = {
    Customers: CustomerNameId[] | null,
    Items: ItemNameNumber[] | null,
    Promotions: PromotionNameId[] | null,
    ProductLines: ProductLineNameNumber[] | null,
    ProductLineCategories: ProductLineCategoryNameNumber[] | null
}

export const PromotionExpirationTemplateHeaderRows_AoA = [
    [
        "AGREEMENT NUMBER",
        "CONTROL NUMBER",
    
        "CUSTOMER ID",
        "CUSTOMER NAME",
        "CUSTOMER ADDRESS",
    
        "SEGMENT",
        "SEGMENT DESC",
        "CHANNEL",
        "CHANNEL DESC",
        "TIER",
        "TIER DESC",
        "BUYING GROUP",
        "BUYING GROUP DESC",
        "CORPORATE AFFILIATION",
        "CORPORATE AFFILIATION DESC",
        "COUNTRY CODE",
        "COUNTRY DESC",
        "PRICE ZONE",
        "PRICE ZONE DESC",
        "FREIGHT ZONE",
    
        "PRODUCT LINE",
        "PRODUCT LINE DESC",
    
        "PRODUCT CATEGORY",
        "PRODUCT CATEGORY DESC",
    
        "ITEM NUMBER",
        "ITEM DESC",
        "MANUFACTURERS NUMBER",
        "GTIN",
    
        //"SUPPLIER FLAG",
        //"JOB TYPE",
        //"JOB TYPE DESC",
        "EMPLOYEE RESPONSIBLE PRICING",
    
        "PROMOTION ID",
        "PROMOTION ID DESC",
        "PROMOTION AMOUNT",
        "UOM",
        "PROMOTION PERCENT",
    
        "MINIMUM VALUE",
        "MINIMUM CODE",
        "MINIMUM DESC",
    
        "MAXIMUM VALUE",
        "MAX CODE",
        "MAXIMUM DESC",
        
        "BEGIN ORDER DATE",
        "END ORDER DATE",
        "BEGIN DELIVERY DATE",
        "END DELIVERY DATE",
        "EXTEND/DELETE/CANCEL/NEW",
        "EXTEND ORDER END DATE",
        "EXTEND DELIVERY END DATE",
        "CONTACT EMAIL",

        "NEW PROMOTION AMOUNT",
        "NEW PROMOTION UOM",
        "NEW BEGINNING ORDER DATE",
        "NEW ENDING ORDER DATE",
        "NEW BEGINNING DELIVERY DATE",
        "NEW ENDING DELIVERY DATE",
    
        "COMMENTS",
    ]
];
